module.exports = ".painel{width:96%;margin:auto}\n"